export class VehicleAvailabilityExceptionsModel {
  id?: number;
  idVehicle?: number;
  idVehicleAvailabilty?: number;
  idOrganization?: number;
  weekDay?: string;
  shift?: string;
  reason?: string;
  createdDate?: any
  createdByUsername?: string;
  enabled?: boolean;

  constructor(options: VehicleAvailabilityExceptionsModel = {}) {
    this.id = options.id || null ;
    this.idVehicle = options.idVehicle || null;
    this.idVehicleAvailabilty = options.idVehicleAvailabilty || null;
    this.idOrganization = options.idOrganization || null;
    this.weekDay = options.weekDay || null;
    this.shift = options.shift || null;
    this.reason = options.reason || null;
    this.createdDate = options.createdDate || null;
    this.createdByUsername = options.createdByUsername || null;
    this.enabled = options.enabled || null;
  }
}
